import { applyDefaultColumnSettings } from "../../../../../utils/utils";
import {
  getBoldText,
  getTotalCell,
} from "./patient/AccountReceivablePatientTable";


export interface AccountReceivableFilterType {
  search?: string;
  // date?: Date | null;
  startDate?: Date | null;
  endDate?: Date | null;
  // grouping?: string | null;
}

// Group by was removed from the AR Summary filters
// export const SUMMARY_GROUPING_OPTIONS = [
//   { label: "30 days", value: "LAST_30_DAYS" },
//   { label: "Quarterly", value: "QUARTERLY" },
//   { label: "Yearly", value: "YEARLY" },
// ];

export type AccountReceivableTab = "summary" | "insurance" | "patient";

// Tabs
export const ACCOUNT_RECEIVABLE_TABS = [
  { label: "Summary", value: "summary" },
  { label: "Insurance", value: "insurance" },
  { label: "Patient", value: "patient" },
];

export const formatCurrency = (value?: number) => (value ? `$${value}` : "-");

// Table Columns


// Default Filter Values
export const DEFAULT_ACCOUNT_RECEIVABLE_FILTER: AccountReceivableFilterType = {
  search: "",
  // date: null,
  startDate: null,
  endDate: null,
  // grouping: null,
};

export const toSafeIsoString = (
  value: string | Date | null | undefined
): string | undefined => {
  if (!value) return undefined;
  const date = new Date(value);
  if (isNaN(date.getTime())) return undefined;
  return date.toISOString();
};

export const UPPER_TABLE_COLUMNS = applyDefaultColumnSettings([
  {
    field: "id",
    headerName: "",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "totalKey",
    headerName: "",
    flex: 1,
    minWidth: 200,
    renderCell: () => getBoldText("Total"),
  },
  {
    field: "duration0To30",
    headerName: "Days 0-30",
    flex: 1,
    minWidth: 100,
    renderCell: ({ value }) => getTotalCell(value),
  },
  {
    field: "duration31To60",
    headerName: "Days 31-60",
    flex: 1,
    minWidth: 100,
    renderCell: ({ value }) => getTotalCell(value),
  },
  {
    field: "duration61To90",
    headerName: "Days 61-90",
    flex: 1,
    minWidth: 100,
    renderCell: ({ value }) => getTotalCell(value),
  },
  {
    field: "duration91To120",
    headerName: "Days 91-120",
    flex: 1,
    minWidth: 100,
    renderCell: ({ value }) => getTotalCell(value),
  },
  {
    field: "duration120Plus",
    headerName: "Days 120+",
    flex: 1,
    minWidth: 100,
    renderCell: ({ value }) => getTotalCell(value),
  },
  {
    field: "total",
    headerName: "Total",
    flex: 1,
    minWidth: 100,
    renderCell: (params) => getTotalCell(params.value),
  },
]);
